import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/cn";

export const Skeleton = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
	<div className={cn("animate-pulse rounded-sm bg-raised", className)} {...props} />
);

interface StateProps {
	title: string;
	description?: string;
	action?: ReactNode;
}

export const EmptyState = ({ title, description, action }: StateProps) => (
	<div className="flex flex-col items-center justify-center gap-2 border border-dashed border-line px-6 py-16 text-center">
		<p className="text-sm font-medium text-ink">{title}</p>
		{description ? <p className="max-w-sm text-xs text-ink-muted">{description}</p> : null}
		{action ? <div className="mt-2">{action}</div> : null}
	</div>
);

export const ErrorState = ({ title, description, action }: StateProps) => (
	<div className="flex flex-col items-start gap-2 border border-line-strong bg-raised px-4 py-4">
		<p className="text-sm font-medium text-ink">{title}</p>
		{description ? <p className="text-xs text-ink-muted">{description}</p> : null}
		{action ? <div className="mt-1">{action}</div> : null}
	</div>
);
